import React from 'react';
import moment from 'moment';
import sAction from 'sAction';
import ResetPassRequest from 'ROOT/views/portal-ern/components/login/ResetPassRequest';
import LoginForm from 'ROOT/views/portal-ern/components/login/LoginForm';
import ResetPass from 'ROOT/views/portal/components/login/ResetPass';
import LoginAonPortal from 'ROOT/views/portal/components/login/login';
import CarouselWidget from './CarouselWidget';
import RequestAccess from './RequestAccess';

export default class Login extends LoginAonPortal {
    constructor() {
        super();
        this.state = {
            backgroundImages: sAction.param.portalLoginImages,
            actualBgImage: sAction.param.portalLoginImages[0],
            actualBgImageIndex: 0,
            prevBgImage: sAction.param.portalLoginImages[0],
            updatingBgImage: false,
        };

        if (this.state.backgroundImages && this.state.backgroundImages.length > 0) {
            setInterval(() => {
                this.changeBackgroundImage();
            }, 6000);
        }
    }

    render() {
        const hasBgImages = sAction.param.showLoginBackgroundImages;
        let backgroundImage;
        let renderVideo = true;
        if (hasBgImages) {
            backgroundImage = (<div
                id={'loginPageBackground'}
                style={{backgroundImage: this.state.backgroundImage}}
            />);
        } else {
            backgroundImage = '';
        }

        let loginWindow;
        if (window.location.hash === '#login/resetPassword' || window.location.hash === '#login/resetPassword/') {
            loginWindow = (
                <ResetPassRequest
                    goToLogin={() => this.goToLogin()}
                />
            );
        } else if (window.location.hash.includes('#login/resetPassword/')) {
            const urlArray = window.location.hash.split('/');
            if (urlArray[1] == 'resetPassword' && urlArray[2]) {
                loginWindow = (
                    <ResetPass
                        goToLogin={() => this.goToLogin()}
                    />
                );
            }
        } else {
            loginWindow = (
                <LoginForm
                    goToResetPassword={() => this.goToResetPassword()}
                    goToRequestAccess={() => this.goToRequestAccess()}
                    redirect={this.props.redirect}
                />
            );
        }
        switch (window.location.hash) {
            // Přihlašovací okno
            case '#login':
            case '#login/':
                // default:
                loginWindow = (
                    <LoginForm
                        goToResetPassword={() => this.goToResetPassword()}
                        goToRequestAccess={() => this.goToRequestAccess()}
                        redirect={this.props.redirect}
                    />
                );
                break;
            // Žádost o reset hesla
            case '#login/resetPassword':
            case '#login/resetPassword/':
                loginWindow = (
                    <ResetPassRequest
                        goToLogin={() => this.goToLogin()}
                    />
                );
                break;
            case '#login/requestAccess':
            case '#login/requestAccess/':
                loginWindow = (
                    <RequestAccess
                        goToLogin={() => this.goToLogin()}
                    />
                );
                renderVideo = false;
                break;
            // Ostatní případy + reset hesla dle tokenu
            default:
                const urlArray = window.location.hash.split('/');
                if (urlArray[1] == 'resetPassword' && urlArray[2]) {
                    loginWindow = (
                        <ResetPass
                            goToLogin={() => this.goToLogin()}
                        />
                    );
                    break;
                }
        }

        switch (this.state.url) {
            // Přihlašovací okno
            case '#login':
            case '#login/':
                // default:
                loginWindow = (
                    <LoginForm
                        goToResetPassword={() => this.goToResetPassword()}
                        goToRequestAccess={() => this.goToRequestAccess()}
                        redirect={this.props.redirect}
                    />
                );
                break;
            // Žádost o reset hesla
            case '#login/resetPassword':
            case '#login/resetPassword/':
                loginWindow = (
                    <ResetPassRequest
                        goToLogin={() => this.goToLogin()}
                    />
                );
                break;
            case '#login/requestAccess':
            case '#login/requestAccess/':
                loginWindow = (
                    <RequestAccess
                        goToLogin={() => this.goToLogin()}
                    />
                );
                renderVideo = false;
                break;
        }

        return (
            <div>
                <div id="loginPageContainer">
                    <div className="navBarLogin">
                        <div className="navBarContainer">
                            <div className="navBarLogo">
                                <a href='#login' onClick={() => this.goToLogin()}><img src="img/ERN_logo_green.png" alt="ERN"/></a>
                            </div>
                            <div className="navBarMenu">
                                <div className="navBarMenuItem">
                                    <a href="https://www.ern.com.mx/web/">ERN</a>
                                </div>
                                <div className="navBarMenuItem">
                                    <a href="mailto:contacto@ern.com.mx">{sAction.translate('LBL_CONTACT_US')}</a>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="contentContainer">
                        <div className={'loginContainerGrid' + (!renderVideo ? ' singleCenter' : '')}>
                            <div className="loginFormContainer">
                                {loginWindow}
                            </div>
                            { renderVideo &&
                                <div className="loginVideoContainer">
                                    <CarouselWidget />
                                    {/* fade from one image to next */}
                                    <div className="loginImagesCarrousel">
                                        <img src={this.state.actualBgImage}
                                            className={'loginImg next ' + (!this.state.updatingBgImage ? ' nextFadeIn' : '')}
                                        />
                                        <img src={this.state.prevBgImage}
                                            className="loginImg prevFadeOut"
                                        />
                                    </div>
                                </div>
                            }
                        </div>

                        <div className="loginPageFooter">
                            <div className="loginPageFooterContainer">
                                <div className="footerCopyright footerItem">
                                    <a href='https://www.ern.com.mx/web/'>{sAction.translate('LBL_PRODUCTS_AND_SERVICES')}</a>
                                    <a href='https://www.ern.com.mx/web/aviso_privacidad?language=es'>{sAction.translate('LBL_PRIVACY_POLICY')}</a>
                                    <a href='https://www.ern.com.mx/web/aviso_privacidad?language=es'>{sAction.translate('LBL_COOKIE_NOTICE')}</a>
                                </div>
                                <div className="footerSocials footerItem">
                                    <a
                                        className="iconfab-facebook"
                                        href='https://www.facebook.com/ERN-Evaluaci%C3%B3n-de-Riesgos-Naturales-113488322134682/'
                                    ></a>
                                    <a
                                        className="iconfab-linkedin"
                                        href='https://www.linkedin.com/company/ern-evaluaci-n-de-riegos-naturales/'
                                    ></a>
                                    <a className="iconfab-twitter" href='https://twitter.com/ERN_Riesgos'></a>
                                    <a className="iconfab-instagram" href='https://www.instagram.com/ern_mex/'></a>
                                </div>
                                <div className="footerCopyrightRights footerItem">
                                    <p>© {moment().format('YYYY')} ERN. {sAction.translate('LBL_ALL_RIGHTS_RESERVED')}.</p>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                {/*
                <div id="loginPage">
                    <div id="loginContentContainer">
                        <div id="loginContainer" style={hasBgImages ? {boxShadow: 'none'} : {}}>
                            <img className="loginContainerLogo" src={sAction.param.companyLogoDark} />

                            <div className="loginContent">
                                {loginWindow}
                            </div>
                        </div>

                        <div className="videoContainer">
                            <div className="videoContainerOverlay"></div>
                            {sAction.param.loginVideo &&
                            <video autoPlay loop muted className="videoPlayer">
                                <source src={sAction.param.loginVideo} type="video/mp4" />
                            </video>}
                            <img src={sAction.param.loginImage} className="videoContainerBgImg" />
                        </div>

                    </div>
                </div> */}
            </div>
        );
    }
}
